import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { RootProvider } from './context/RootContext';
import { AuthProvider } from './context/AuthContext';
import { installGlobalErrorHandlers } from './helpers/clientLogger';
import App from './App';
import './assets/css/colors.css';
import './index.scss';

installGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RootProvider>
    <AuthProvider>
      <App />
    </AuthProvider>
  </RootProvider>
);

reportWebVitals();
